import { render, staticRenderFns } from "./shipment-view.vue?vue&type=template&id=1ae0ef83&scoped=true"
import script from "./shipment-view.vue?vue&type=script&lang=js"
export * from "./shipment-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0ef83",
  null
  
)

export default component.exports